import { DocumentationIssueTypeCategoryEnum } from "@altertec_gparn/lib";
import { Expose } from "class-transformer";

export class CreateDocumentationIssueTypeDto {
  @Expose()
  name: string;

  @Expose()
  category: DocumentationIssueTypeCategoryEnum;
}
